import { motion } from "framer-motion";
import { IMAGES } from "@/data/content";

const RULES = [
  { text: "no sports betting", stroke: "#ff5757", rotate: -6, size: "text-5xl md:text-7xl" },
  { text: "no alcohol", stroke: "#79AFFF", rotate: 3, size: "text-5xl md:text-7xl" },
  { text: "no drugs", stroke: "#0e0e14", rotate: -3, size: "text-5xl md:text-7xl" },
];

export const Manifesto = () => {
  return (
    <section id="story" data-testid="manifesto" className="bg-white py-20 md:py-32 px-5 md:px-10 overflow-hidden">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-14 md:mb-20">
          <span className="font-outfit text-xs uppercase tracking-widest text-coral">My Rules</span>
          <h2 className="font-anton uppercase text-6xl md:text-8xl leading-[0.85] text-obsidian mt-3">
            How I Play
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          {/* Scattered outlined rules */}
          <div className="flex flex-col items-center gap-6 md:gap-10 py-4">
            {RULES.map((r, i) => (
              <motion.span
                key={r.text}
                initial={{ opacity: 0, scale: 0.5, rotate: r.rotate * 3 }}
                whileInView={{ opacity: 1, scale: 1, rotate: r.rotate }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ type: "spring", stiffness: 120, damping: 10, delay: i * 0.12 }}
                whileHover={{ rotate: 0, scale: 1.06 }}
                className={`font-anton uppercase leading-none select-none ${r.size}`}
                style={{ color: "transparent", WebkitTextStroke: `2.5px ${r.stroke}` }}
              >
                {r.text}
              </motion.span>
            ))}
          </div>

          {/* Justin & Rob photo + speech bubble */}
          <motion.div
            initial={{ opacity: 0, x: 40, scale: 0.92 }}
            whileInView={{ opacity: 1, x: 0, scale: 1 }}
            viewport={{ once: true }}
            transition={{ type: "spring", stiffness: 90, damping: 13 }}
            className="relative flex justify-center"
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.6, rotate: -8 }}
              whileInView={{ opacity: 1, scale: 1, rotate: -4 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4, type: "spring", stiffness: 180, damping: 11 }}
              className="absolute -top-2 left-2 md:left-6 z-10"
            >
              <motion.div
                animate={{ rotate: [-4, 3, -4] }}
                transition={{ repeat: Infinity, duration: 4, ease: "easeInOut" }}
                className="relative bg-coral text-white font-anton uppercase text-base md:text-2xl px-5 py-3 rounded-2xl shadow-xl whitespace-nowrap"
              >
                Family friendly fun only! 🔥
                <span className="absolute -bottom-1.5 left-10 h-4 w-4 bg-coral rotate-45 rounded-[3px]" />
              </motion.div>
            </motion.div>
            <div className="w-full max-w-lg mt-8 rounded-3xl overflow-hidden border-4 border-white shadow-2xl">
              <img
                src={IMAGES.justinRob}
                alt="Justin and Rob"
                className="w-full object-cover"
              />
            </div>

            <motion.div
              initial={{ opacity: 0, scale: 0.7, y: 12 }}
              whileInView={{ opacity: 1, scale: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.5, type: "spring", stiffness: 180, damping: 13 }}
              className="absolute -bottom-10 right-0 md:-right-4 z-10 max-w-[16rem] rotate-2"
            >
              <div className="relative bg-yellow text-obsidian font-outfit font-bold text-xs md:text-sm px-4 py-3 rounded-2xl shadow-xl leading-snug">
                ALSO! this is Producer Rob, the 🐐 behind editing, thumbnails, and <span className="whitespace-nowrap">partnerships 🤝</span>
                <span className="absolute -top-1.5 left-10 h-4 w-4 bg-yellow rotate-45 rounded-[3px]" />
              </div>
            </motion.div>
          </motion.div>
        </div>

        {/* Big statement */}
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          className="font-anton uppercase text-center leading-[0.95] text-3xl md:text-6xl text-obsidian mt-16 md:mt-24 max-w-4xl mx-auto"
        >
          If it isn&apos;t <span className="text-coral">family friendly fun</span>, I don&apos;t want it!
        </motion.p>
      </div>
    </section>
  );
};
